import styled from "styled-components";
import React from "react";
import InputField from "components/UI/InputField";
import { RELATE_ANSWER_FIELDS } from "../RelateAnswerAction.const";
import { Button } from "@mui/material";
import CharacterRelateContainEdit from "components/common/character/CharacterForm/CharacterRelateEdit/CharacterRelateContainEdit";
import { ReactRefI } from "type/common/ref.type";

type RelateAnswerActionFormProps = {
  control: any;
  handleSubmit: Function;
  onSubmit: Function;
  relateContainRef: ReactRefI<string[]>;
  containLength: number;
};

const RelateAnswerActionForm = ({
  control,
  handleSubmit,
  onSubmit,
  relateContainRef,
  containLength,
}: RelateAnswerActionFormProps) => {
  return (
    <FormAnswer>
      <DivField>
        <InputField
          name={RELATE_ANSWER_FIELDS.ANSWER_PRONOUNCE.name}
          control={control}
          label={RELATE_ANSWER_FIELDS.ANSWER_PRONOUNCE.label}
          defaultValue={""}
          autoFocus={false}
        />
      </DivField>
      <DivField>
        <InputField
          name={RELATE_ANSWER_FIELDS.ANSWER_MEANING.name}
          control={control}
          label={RELATE_ANSWER_FIELDS.ANSWER_MEANING.label}
          defaultValue={""}
          autoFocus={false}
        />
      </DivField>
      {containLength > 0 && (
        <DivContain>
          <CharacterRelateContainEdit
            resultRef={relateContainRef}
            label={`contain (${containLength})`}
            resultMax={containLength}
          />
        </DivContain>
      )}
      <DivOk>
        <Button onClick={handleSubmit(onSubmit)} type="submit">
          OK
        </Button>
      </DivOk>
    </FormAnswer>
  );
};

const FormAnswer = styled.form`
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;
`;

const DivField = styled.div`
  margin-top: 1rem;

  div {
    width: 100%;
  }
`;

const DivContain = styled.div`
  margin-top: 1rem;
`;

const DivOk = styled.div`
  margin-top: 1rem;
`;

export default RelateAnswerActionForm;
